module.exports = __webpack_public_path__ + "img/fontawesome.912ec66d.svg";